import { EvtSelect } from "components/select";
import { getDirectusField } from "directus/src/operations";
import { useFetch } from "hooks/src/useFetch";
import React from "react";

const SelectStatus = ({
  collection,
  className,
  value,
  onChange,
  placeholder,
  remove = [],
  ...props
}) => {
  const { data, isLoading, isError } = useFetch({
    queryKey: [collection, "statuses"],
    queryFn: async () => {
      const response = await getDirectusField(collection, "status");

      const data = response.meta.options.choices.map((status) => {
        let name = status.text;
        if (collection === "directus_users") {
          name = status.value
            ?.split("_")
            .map(
              (word) =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
            )
            .join(" ");
        }
        return { name: name, id: status.value };
      });

      return data;
    },
    select: (data) =>
      remove?.length > 0
        ? data.filter((status) => !remove.includes(status.text))
        : data,
    enabled: !!collection,
  });

  console.log("data", data);

  return (
    <EvtSelect
      data={data}
      isLoading={isLoading}
      className={className}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      type="filter"
      {...props}
    />
  );
};

export default SelectStatus;
